import Checkbox from '@components/v2/form/Checkbox/Checkbox';
import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import LangEnum from '../../../lang/LangEnum';
import { useTranslation } from '../../translation/TranslationContext';

interface CopyOrderWithConditionsProps {
  copyOrderWithConditions: boolean;
  disabled: boolean;
  onChangeCopyOrderWithConditions: (value: boolean) => void;
}

const CopyOrderWithConditions = ({
  copyOrderWithConditions,
  disabled,
  onChangeCopyOrderWithConditions,
}: CopyOrderWithConditionsProps) => {
  const { translate } = useTranslation();

  const handleChangeCopyOrderWithConditions = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChangeCopyOrderWithConditions(event.target.checked);
  };

  return (
    <Tooltip
      disabled={!disabled}
      placement="bottom-left"
      TooltipContent={translate(LangEnum.COPY_ORDER_WITH_CONDITIONS_BLOCKED_TOOLTIP)}
    >
      <Checkbox
        label={translate(LangEnum.COPY_ORDER_WITH_CONDITIONS_LABEL)}
        checked={copyOrderWithConditions}
        disabled={disabled}
        onChange={handleChangeCopyOrderWithConditions}
      />
    </Tooltip>
  );
};

export default CopyOrderWithConditions;
